module.exports = __webpack_public_path__ + "img/edit.a7df1179.svg";